<template>
  <div class="settings-fields">
    <div class="field-group">
      <div class="flabel">
        <FieldStatusIcon :ok="Boolean(settings['yclientsChannel'])" />
        <span>Канал отправки сообщений из YCLIENTS (по умолчанию)</span>
      </div>
      <CustomActivatorSelect
        :value="selectedYclientsChannel"
        @input="updateYclientsChannel"
        :items="yclientsChannelOptions"
        item-value="value"
        item-name="label"
        :multiple="false"
        class="custom-input mock-input"
      >
        <template v-slot:activator="{ selected, _id }">
          <BaseInputOutlined
            :id="_id"
            :value="selected ? selected.label : ''"
            label="Выберите канал"
            readonly
            class="select-input"
            append-icon="mdi-menu-down"
            hide-details
          />
        </template>
      </CustomActivatorSelect>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import BaseInputOutlined from '@/components/inputs/BaseInputOutlined.vue'
import CustomActivatorSelect from '@/components/inputs/CustomActivatorSelect.vue'
import FieldStatusIcon from '@/components/ClientNotifications/NotificationSettingsBlocks/FieldStatusIcon.vue'

export default defineComponent({
  name: 'YclientsMessagesBlock',
  components: { BaseInputOutlined, CustomActivatorSelect, FieldStatusIcon },
  props: {
    settings: { type: Object, required: true },
    yclientsChannelOptions: { type: Array, required: true },
    selectedYclientsChannel: { type: [String, Object, null], default: null },
    updateYclientsChannel: { type: Function, required: true },
  },
})
</script>

<style lang="sass" scoped>
.field-group
  display: flex
  flex-direction: column
  gap: 9px

.flabel
  display: flex
  align-items: center
  gap: 7px
  font-size: 13px
  color: #1F2440
</style>
